import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

// AddButton Component
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      width: 100,
    },
  })
)

export default useStyles
